import { combineReducers } from "redux";

//Constants
import { alertsSectionTabs } from "src/constants";

//Section Reducer Factory
import {
  createSectionFiltersReducer,
  createSectionSelectedFilterIdReducer
} from "src/ui_processors/global/reducer_creators";

//UI Processors
import SingleValue from "src/ui_processors/single_value";

// Constants
import { sections } from "src/constants";

export const evaluationListTotalSkinReducers = combineReducers({
  filters: createSectionFiltersReducer(sections.evaluationListTotalSkin),
  selectedFilterId: createSectionSelectedFilterIdReducer(
    sections.evaluationListTotalSkin
  ),
  selectedTab: SingleValue.createReducer(
    "selectedTab",
    alertsSectionTabs.evaluationList
  ),
  totalSkinEvaluationPageLimit: SingleValue.createReducer(
    "totalSkinEvaluationPageLimit",
    50
  )
});
